import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=4d3e4946&scoped=true&"
import script from "./PageBase.vue?vue&type=script&lang=js&"
export * from "./PageBase.vue?vue&type=script&lang=js&"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=4d3e4946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e4946",
  null
  
)

export default component.exports